'use strict';

export default angular
  .module('maestro.services.data.cloudConfig', [
    'maestro.services.webcore'
  ])
  .service('CloudConfigService', CloudConfigService)
  .name;

function CloudConfigService(webcore, $q) {

  /**
   * Gets clouds configuration from the main (front) server.
   */
  this.getClouds = () => {
    return $q.when(
      webcore.services.cloudConfig.getClouds()
        .then(data => $q.resolve(data), err => $q.reject(err))
    );
  };

  /**
   * Gets currently selected cloud info.
   */
  this.getCurrentCloud = () => {
    return $q.when(
      webcore.services.cloudConfig.getCurrentCloud()
        .then(data => $q.resolve(data), err => $q.reject(err))
    );
  };

  /**
   * Sets (selects) cloud as the new current cloud to work with.
   */
  this.setCurrentCloud = (cloud) => {
    return $q.when(
      webcore.services.cloudConfig.setCurrentCloud(cloud)
        .then(data => $q.resolve(data), err => $q.reject(err))
    );
  };

  /**
   * Gets API base URL of the current cloud
   * @returns {Promise<string>}
   */
  this.getBaseUrl = () => {
    return $q.when(
      webcore.services.cloudConfig.getBaseUrl()
        .then(data => $q.resolve(data), err => $q.reject(err))
    );
  };




}
